export default __webpack_public_path__ + "static/media/startArea.d6c302bf.png";